import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {Entity} from '../../../../models/entity.model';
import {ScrollPosition} from '../../../../models/browseDocuments.model';
import {AsyncPipe} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';
import {MatMenuTrigger} from '@angular/material/menu';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FileService} from '../../../../_services/api/file.service';

@Component({
  selector: 'app-inner-html',
  templateUrl: './inner-html.component.html',
  styleUrls: ['./inner-html.component.scss'],
  providers: [AsyncPipe],
  encapsulation: ViewEncapsulation.None
})
export class InnerHTMLComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @Input() inputData: any;
  @Input() documentHeight: number;
  @Input() scale: string;
  @Input() currentPage: ScrollPosition;
  @Output() deleteEntity: EventEmitter<Entity> = new EventEmitter();
  @Output() pageChange: EventEmitter<ScrollPosition> = new EventEmitter();
  @Output() selectedText: EventEmitter<any> = new EventEmitter();
  @ViewChild('el') el: ElementRef;

  public removeEventListener: () => void;
  entities: Entity[];
  // labels: string[];

  constructor(private elementRef: ElementRef, private renderer: Renderer2, private fileService: FileService, private sanitizer: DomSanitizer,
              private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    // this.labels = ['location', 'date', 'person', 'id'];
  }

  ngAfterViewInit() {
    this.addActionToButtons();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.addActionToButtons();
    if (changes.currentPage !== undefined && changes.currentPage.currentValue !== undefined) {
      if (changes.currentPage.currentValue.fromButton) {
        this.scrollTo(changes.currentPage.currentValue.page.toString());
      }
    }
  }

  public addActionToButtons(): void {
    this.entities = [];
    if (this.el) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.inputData);
      const clickButtons = this.el.nativeElement.querySelectorAll('span.chip');
      const images = this.el.nativeElement.querySelectorAll('img');
      images.forEach(x => {
        this.fileService.getImage(x.src).subscribe(
          res => {
            this.createImageFromBlob(res, x);
          }
        );
      });

      for (let i = 0; i < clickButtons.length; i++) {
        const button  = document.createElement('button');
        const newHeight = Math.round(clickButtons[i].getBoundingClientRect().height * 0.7);
        const marginTop = Math.round(clickButtons[i].getBoundingClientRect().height * 0.15);
        button.style.height = newHeight.toString() + 'px';
        button.style.width = newHeight.toString() + 'px';
        button.style.marginTop = marginTop.toString() + 'px';
        button.style.marginLeft = '5px';
        button.style.cursor = 'pointer';

        this.entities.push(new Entity( clickButtons[i].querySelector('span').textContent, clickButtons[i].getAttribute('type')));
        clickButtons[i].append(button);
        this.removeEventListener = this.renderer.listen(button, 'click', (event) => {
          if (event.target instanceof HTMLButtonElement) {
            this.deleteEntity.emit(this.entities[i]);
          }
        });
      }
      this.el.nativeElement.querySelectorAll('.pages').forEach(node => {
        node.style.outline = '1px solid #595959';
        node.style.marginBottom = '10px';
      });

    }
  }

  createImageFromBlob(image: Blob, imgElement) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      imgElement.setAttribute('src', reader.result);
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }
  }

  onSectionChange($event: number) {
    this.currentPage.page = $event;
    this.currentPage.fromButton = false;
    this.pageChange.emit(this.currentPage);
  }

  scrollTo(section) {
    if (this.el !== undefined) {
      this.el.nativeElement.querySelector('#page' + section).scrollIntoView({behavior: 'smooth'});
    }
  }

  selectText(event: any) {
    const text = window.getSelection().toString();
    if (text.length > 100) {
      window.getSelection().removeAllRanges();
      this.snackBar.open('Your marking is too long, please mark smaller part of the text.', 'close', {
        duration: 2000,
      });
    } else {
      this.selectedText.emit(event);
    }
  }

  deselect() {
    window.getSelection().removeAllRanges();
  }

}
